export const containerLoad = {
  fcl: "fcl",
  lcl: "lcl",
  air: "air",
  ltl: "ltl",
};
